import { render, staticRenderFns } from "./PageIntro.vue?vue&type=template&id=0c3dc86b&scoped=true"
import script from "./PageIntro.vue?vue&type=script&lang=js"
export * from "./PageIntro.vue?vue&type=script&lang=js"
import style0 from "./PageIntro.vue?vue&type=style&index=0&id=0c3dc86b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3dc86b",
  null
  
)

export default component.exports